import find from 'lodash/find';

export const trackSectionsTitlesProperties = (payload, properties) => {
  properties.push(...[
      {label: 'Report', key: 'COVER_PAGE'},
      {label: 'Target Property Page', key: 'TARGET_PROPERTY'},
      {label: 'Comparable Sales Page', key: 'COMPARABLE_SALES'},
      {label: 'Comparable Listings Page', key: 'COMPARABLE_LISTINGS'},
      {label: 'Summary Page', key: 'SUMMARY'},
    ]
      .filter(s => find(payload.sections, {name: s.key}))
      .map(s => {
        return {
          label: `Title - ${s.label}`,
          value: find(payload.sections, {name: s.key}).title
        };
      })
  );
};